var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "get-action": _vm.queryApi,
          selection: _vm.selection,
          "col-span": _vm.colSpan,
          serial: _vm.serial,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { showAll: false, enterable: false },
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CustomerName"),
                              prop: "cusId",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("table.statusText"),
                          prop: "statusList",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            clearable: false,
                            multiple: "",
                            "option-list": _vm.statusList,
                          },
                          on: { change: _vm.chooseSome },
                          model: {
                            value: _vm.queryParams.statusList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "statusList", $$v)
                            },
                            expression: "queryParams.statusList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagementAdd.onTime"),
                          prop: "queryParamsTime_start",
                        },
                      },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            placeholder: _vm.$t("AccountManagementAdd.onTime"),
                          },
                          model: {
                            value: _vm.queryParamsTime_start,
                            callback: function ($$v) {
                              _vm.queryParamsTime_start = $$v
                            },
                            expression: "queryParamsTime_start",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagementAdd.offTime"),
                          prop: "queryParamsTime_end",
                        },
                      },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            placeholder: _vm.$t("AccountManagementAdd.offTime"),
                          },
                          model: {
                            value: _vm.queryParamsTime_end,
                            callback: function ($$v) {
                              _vm.queryParamsTime_end = $$v
                            },
                            expression: "queryParamsTime_end",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("workOrderList.Operator"),
                          prop: "operater",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("workOrderList.Operator"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.operater,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "operater", $$v)
                            },
                            expression: "queryParams.operater",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "cusId"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerList.bjGet(
                                                scope.row.cusId
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "status"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[col.prop] == "1"
                                                  ? _vm.$t("completedText")
                                                  : scope.row[col.prop] == "2"
                                                  ? _vm.$t("canceledText")
                                                  : ""
                                              )
                                            ),
                                          ]),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }